import { type FC } from 'react';

interface LoadingStateProps {
  message?: string;
}

const LoadingState: FC<LoadingStateProps> = ({ message = 'Carregando...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-10 h-10 border-3 border-background-200 border-t-primary-500 rounded-full animate-spin mb-4"></div>
      <p className="text-sm text-foreground-500 font-medium">{message}</p>
    </div>
  );
};

export default LoadingState;